<script lang="ts">
  export let legend: string;
</script>

<fieldset class="Fieldset">
  <legend class="Fieldset-legend">
    {legend}
  </legend>
  <slot />
</fieldset>

<style>
  .Fieldset {
    border: 0;
  }

  .Fieldset-legend {
    color: var(--color-blue);
    font-family: var(--font-family-decoration);
    font-weight: 500;
    margin-block-end: var(--size-15);
  }
</style>
